import React, { Component, createRef } from "react";
import { withRouter, Link } from "react-router-dom";
// import queryString from 'query-string'
import Logo from "../../assets/logomarca.png";
import api from "../../services/api";
import { login } from "../../services/auth";
import mail from "../../services/mail";
import Email from "../Email";
import { renderEmail } from 'react-html-email'

import "../../styles/login.css";

class Login extends Component {

  constructor() {
    super();
    this.iconRevealPassword = createRef();
    this.state = {
      email: '',
      password: '',
      error: '',
      errorRecover: '',
      show: false,
      login: true,
      isRevealPassword: false,
      isRevealEnter: false,
      isRevealRecover: false,
    }
  }

  Email(email, password) {

    let conteudo = '';
    let subject = '';

    subject = 'Bem vindo ao Dommus - Recuperação de senha';
    conteudo = renderEmail(<Email email={email} password={password}/>);

    mail.post('vendaonline/dommus-mail',
    {
      email: email,
      subject: subject,
      conteudo: conteudo
      
    })
    .then((response) => {
      console.log(response)
    }).catch((error) => {
      console.log(error)
    });    
  }

  togglePassword = event => {
    this.setState({ isRevealPassword: !this.state.isRevealPassword });
  }

  handleLogin = async e => {
    e.preventDefault();
    this.setState({ isRevealEnter: true });
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ 
        isRevealEnter: false, 
        error: "Preencha e-mail e senha para continuar!" });
    } else {
      try {
        const response = await api.post("auth/login", { email, password });
        login(response);
        this.props.history.push("/cliente");
      } catch (err) {
        this.setState({
          isRevealEnter: false,
          error: "E-mail ou senha incorreto."
        });
      }
    }
  };

  handleRecover = async e => {   
    this.setState({ isRevealRecover: true });
    const { email } = this.state;
    if (!email) {
      this.setState({ 
        isRevealRecover: false,
        errorRecover: "Campo Obrigatório" });
    } else {
      try {
        await api.post("auth/recover", { email });
        this.setState({ 
          isRevealRecover: false, 
          errorRecover: "" });
          this.Email(this.state.email, '123456');
      } catch (err) {
        this.setState({
          isRevealRecover: false,
          errorRecover: "E-mail não existe."
        });
      }
    }
  };

  // componentDidMount() {
  //   const values = queryString.parse(this.props.location.search);
  //   this.setState({ 
  //     email: values.mail,
  //     password: values.senha
  //   })
  // }

  render() {

    const { isRevealPassword, isRevealEnter, isRevealRecover } = this.state;
    // const values = queryString.parse(this.props.location.search);

    return (
      <>
        <div className="login-wrapper">
          <div className="logo-wrapper">
            <div id="caixa_logo" className="logo-login">
              <img src={Logo} alt="Dommus logo" />
            </div>
          </div> 
          <div id="central" className="login-box">
          { this.state.login ? 
          <>
            <div className="welcome animate-fade" >Seja bem vindo</div>
            <div id="caixa_login" className="login-form">
              <form id="form_autenticacao" className="animate-fade" onSubmit={this.handleLogin} autoComplete={'on'}>
                {this.state.error && <small className="form-text text-danger">{this.state.error}</small>}
                <div className="form-group">
                  <label htmlFor="campo_login">Login</label>
                  <input
                    name="email"
                    id='email'
                    // type="email" defaultValue={values.mail === null ? '' : values.mail}
                    onChange={e => this.setState({ email: e.target.value })}
                    autoComplete={'on'}
                    className="form-autenticacao-input"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="campo_senha" style={{ float: 'left', marginTop: '10px', marginRight: '10px' }}>Senha</label>
                  <div title="Exibir senha" onClick={this.togglePassword} ref={this.iconRevealPassword} style={{ cursor: 'pointer', textAlign: 'right' }}>
                    {isRevealPassword ? <i className="fa fa-eye" style={{ marginTop: '15px', color: 'green' }}></i> : <i className="fa fa-eye-slash" style={{ marginTop: '15px', color: 'red' }}></i>}
                  </div>
                  <input
                    name="password"
                    id='password'
                    type={isRevealPassword ? "text" : "password"}
                    // defaultValue={values.senha === null ? '' : values.senha}
                    onChange={e => this.setState({ password: e.target.value })}
                    autoComplete={'on'}
                    className="form-autenticacao-input"
                  />
                </div>
                <button type="submit" className="btn btn-primary" id="autenticar" name="autenticar">
                  <i className="fas fa-sign-in-alt"></i>{isRevealEnter ? "AUTENTICANDO..." : "Entrar"}
                </button>
                <div id="preferencia-senha" className="row">
                    <div className="custom-control custom-checkbox lembrar-senha col-lg-6 col-12">
                        {/* <input type="checkbox" className="custom-control-input" id="lembrar-senha"/> */}
                        {/* <label className="custom-control-label" htmlFor="lembrar-senha">Lembrar senha</label> */}
                    </div>
                    <div className="col-lg-6 col-12">
                        <a href={"#recover"} id="toggleForm" onClick={() => { this.setState({ login: !this.state.login }) }}>Recuperar senha</a>
                    </div>
                </div>
              </form>
            </div>
            </>
          : 
        <>
        <div className="welcome animate-fade">Recupere sua senha</div>
        <div id="caixa_login" className="login-form">
          <form id="form_recuperar" className="animate-fade" autoComplete={'off'}>
            <div id="recuperar-senha" className="animate-fade">
                <div className="forms-senha" id="recuperar-senha">
                    <h5>Enviaremos para o e-mail a confirmação da alteração de senha. </h5>
                    <div className="form-group">
                        <label htmlFor="campo_recuperar_senha">Digite seu e-mail:</label>
                        <input 
                        type="text" 
                        className="form-control" 
                        name="campo_recuperar_senha"
                        onChange={e => this.setState({ email: e.target.value })}
                        />
                        {this.state.errorRecover && <small className="form-text text-danger">{this.state.errorRecover}</small>}
                    </div>
                    <button type="button" onClick={this.handleRecover} className="btn btn-primary btn-salvar recuperar-senha-btn">{isRevealRecover ? "ENVIANDO..." : "Recuperar senha"}</button>
                    <a href={"#login"} onClick={() => { this.setState({ login: !this.state.login }) }}>Fazer login</a>
                </div>
            </div>
          </form>
        </div>
        </>
          }
          </div>
          
          <div onClick={() => { this.setState({ show: !this.state.show }) }} className="contact-info" data-toggle="tooltip" data-placement="right" data-trigger="hover" title="Suporte">
            <svg enableBackground="new 0 0 476 476" version="1.1" viewBox="0 0 476 476" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg">
              <path d="m400.85 181v-18.3c0-43.8-15.5-84.5-43.6-114.7-28.8-31-68.4-48-111.6-48h-15.1c-43.2 0-82.8 17-111.6 48-28.1 30.2-43.6 70.9-43.6 114.7v18.3c-34.1 2.3-61.2 30.7-61.2 65.4v28.6c0 36.1 29.4 65.5 65.5 65.5h36.9c6.6 0 12-5.4 12-12v-135.7c0-6.6-5.4-12-12-12h-17.2v-18.1c0-79.1 56.4-138.7 131.1-138.7h15.1c74.8 0 131.1 59.6 131.1 138.7v18.1h-17.2c-6.6 0-12 5.4-12 12v135.6c0 6.6 5.4 12 12 12h16.8c-4.9 62.6-48 77.1-68 80.4-5.5-16.9-21.4-29.1-40.1-29.1h-30c-23.2 0-42.1 18.9-42.1 42.1s18.9 42.2 42.1 42.2h30.1c19.4 0 35.7-13.2 40.6-31 9.8-1.4 25.3-4.9 40.7-13.9 21.7-12.7 47.4-38.6 50.8-90.8 34.3-2.1 61.5-30.6 61.5-65.4v-28.6c0.1-34.6-26.9-63.1-61-65.3zm-296.1 135.4h-24.9c-22.9 0-41.5-18.6-41.5-41.5v-28.6c0-22.9 18.6-41.5 41.5-41.5h24.9v111.6zm163.5 135.6h-30.1c-10 0-18.1-8.1-18.1-18.1s8.1-18.1 18.1-18.1h30.1c10 0 18.1 8.1 18.1 18.1s-8.1 18.1-18.1 18.1zm169.7-177.1c0 22.9-18.6 41.5-41.5 41.5h-24.9v-111.6h24.9c22.9 0 41.5 18.6 41.5 41.5v28.6z" />
            </svg>
          </div>
          {
            this.state.show ?
              <div className="contact-box contact-box-animate">
                <ul>
                  <li>
                    <b>Telefone:</b>
                    <p>31 3889-9776</p>
                  </li>
                  <li>
                    <b>Whatsapp:</b>
                    <p>31 98489-5755</p>
                  </li>
                  <li>
                    <b>E-mail:</b>
                    <p>suporte@dommus.com.br</p>
                  </li>
                  <li>
                    <b>Redes Sociais:</b>
                    <div className="redes">
                      <p><Link to="#">Facebook</Link></p>
                      <p><Link to="https://www.linkedin.com/company/dommus-sistemas/">LinkedIn</Link></p>
                    </div>
                  </li>
                </ul>
              </div>
              : null
          }
        </div>
      </>
    );
  }
}

export default withRouter(Login);